import Avatar from '../../components/@extended/Avatar';
import { stringAvatar } from '../../utils/avatar';
import { User } from '../../graphql/types';
import { SizeProps } from '../../types/extended';
import { AppConfig } from '../../config';
import { getUserProfileFullName } from '../../utils/users';
import { useEffect, useState } from 'react';

interface ProfileAvatarProps {
  user: Partial<User>;
  size: SizeProps;
}

interface ImageCache {
  [key: string]: string;
}

const imageCache: ImageCache = {};

const loadImage = (src: string): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    if (imageCache[src]) {
      resolve(imageCache[src] as unknown as HTMLImageElement);
    } else {
      const img = new Image();
      img.onload = () => {
        imageCache[src] = src;
        resolve(img);
      };
      img.onerror = reject;
      img.src = src;
    }
  });
};

const ProfileAvatar = ({ user, size }: ProfileAvatarProps) => {
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const avatar = user?.data?.avatar || user?.company?.logo;
  useEffect(() => {
    if (avatar) {
      const fullSrc = `${AppConfig.apiRoot}files/avatar/${avatar}`;
      loadImage(fullSrc)
        .then(() => setImageSrc(fullSrc))
        .catch((error) => console.error('Error loading image:', error));
    }
  }, [avatar]);

  if (imageSrc) {
    return <Avatar alt={getUserProfileFullName(user)} src={imageSrc} size={size} transparent/>;
  }
  return <Avatar alt={getUserProfileFullName(user)} {...stringAvatar(getUserProfileFullName(user))} size={size} />;
};

export default ProfileAvatar;
